import {
  CheckArgumentsTemplateListView,
  type CheckArgumentsTemplateListConfig,
} from "../check-arguments-templates-shared";

const config: CheckArgumentsTemplateListConfig = {
  listApiPath:
    "/api/internal/client-portal/check-arguments-templates/reference/",
  settingsPathPrefix: "reference-check-templates",
  pageTitle: (t) => t("Reference"),
  testIdPrefix: "reference-check-template",
  apiPathPrefix: "reference",
  filterBarTestId: "reference-check",
  showCertnForDefaultTemplateWithoutCreator: false,
};

export const ReferenceCheckTemplateListView =
  CheckArgumentsTemplateListView(config);
